import styled, { css } from 'styled-components';
import { COMPACT_WINDOW_MEDIA } from '../../constants';

export const StepList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${COMPACT_WINDOW_MEDIA} {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }
    `}
`;

export const StepItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${COMPACT_WINDOW_MEDIA} {
        gap: 12px;
        padding: 12px;
      }
    `}

  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
`;

export const StepGrid = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const StepCard = styled.li`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
`;

export const StepNumber = styled.span`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ theme, $variant }) =>
    $variant === 'danger'
      ? theme.colors.porterRed50
      : theme.colors.porterBlue50};
  color: ${({ theme, $variant }) =>
    $variant === 'danger'
      ? theme.colors.porterRed500
      : theme.colors.porterBlue500};
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StepTitle = styled.strong`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

export const StepText = styled.span`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;
